const constants = {
  ADD_BAR_NOTIFICATION: 'Notification/ADD_BAR_NOTIFICATION',
  ADD_MODAL_NOTIFICATION: 'Notification/ADD_MODAL_NOTIFICATION',
  CLEAR_BAR_NOTIFICATION: 'Notification/CLEAR_BAR_NOTIFICATION',
  CLEAR_MODAL_NOTIFICATION: 'Notification/CLEAR_MODAL_NOTIFICATION',
  NOTIFY_ERROR: 'Notification/NOTIFY_ERROR',
  NOTIFY_SUCCESS: 'Notification/NOTIFY_SUCCESS',

  // E3a — Working Circle Notifications
  FETCH_WORKING_CIRCLE_NOTIFICATIONS: 'Notification/FETCH_WORKING_CIRCLE_NOTIFICATIONS',
  FETCH_WORKING_CIRCLE_NOTIFICATIONS_REQUEST: 'Notification/FETCH_WORKING_CIRCLE_NOTIFICATIONS_REQUEST',
  FETCH_WORKING_CIRCLE_NOTIFICATIONS_SUCCESS: 'Notification/FETCH_WORKING_CIRCLE_NOTIFICATIONS_SUCCESS',
  FETCH_WORKING_CIRCLE_NOTIFICATIONS_FAILURE: 'Notification/FETCH_WORKING_CIRCLE_NOTIFICATIONS_FAILURE',

  // Social overlap dismiss — localStorage only, no server call. Dispatched so Redux
  // items update immediately and the badge count re-evaluates via mapStateToProps.
  DISMISS_SOCIAL_OVERLAP_NOTIFICATION: 'Notification/DISMISS_SOCIAL_OVERLAP_NOTIFICATION',

  FETCH_DISMISS_NOTIFICATION: 'Notification/FETCH_DISMISS_NOTIFICATION',
  FETCH_DISMISS_NOTIFICATION_REQUEST: 'Notification/FETCH_DISMISS_NOTIFICATION_REQUEST',
  FETCH_DISMISS_NOTIFICATION_SUCCESS: 'Notification/FETCH_DISMISS_NOTIFICATION_SUCCESS',
  FETCH_DISMISS_NOTIFICATION_FAILURE: 'Notification/FETCH_DISMISS_NOTIFICATION_FAILURE',
}

export default constants
